import React from "react";
import {
  Card,
  Flex,
  Text,
  Button,
  Tooltip,
  Toolbar,
  Grid,
} from "@fluentui/react-northstar";
import {
  BroadcastIcon,
  BellIcon,
  PlugsIcon,
  SyncIcon,
  AppsIcon,
  TranscriptIcon,
} from "@fluentui/react-icons-northstar";
import {
  Outlet,
  useNavigate,
  useSearchParams,
  useLocation,
  useOutletContext,
} from "react-router-dom";
import { setRouteInLocalStorage } from "../../../shared/contexts/Context";
import MonitoringService from "../../../services/monitoringservice";
import "./monitoring.scss";
import { OPERATIONSTATUS } from "../../../shared/appcomponents/enums";
import StarCustomer from "../../../../assets/images/icon-user-star.svg";

const ProvisioningDashboard = (props) => {
  const [viewArea, setViewArea] = React.useState("");
  const [area, setArea] = React.useState("");
  const [loading, setLoading] = React.useState(true);
  // const [monitoringHome, setMonitoringHome] = React.useState(null);
  const location = useLocation();
  let navigate = useNavigate();
  const routeChange = (path, varea, area) => {
    setViewArea(varea);
    setArea(area);
    setRouteInLocalStorage("contentUrl_dashboards", path);
    navigate(path);
  };
  const [dbInsCriCount, setdbInsCriCount] = React.useState("");
  const [dbInsWarCount, setdbInsWarCount] = React.useState("");
  const [provInsCriCount, setprovInsCriCount] = React.useState("");
  const [provInsWarCount, setprovInsWarCount] = React.useState("");
  const [viewType, setViewType] = React.useState("");
  const [searchParams] = useSearchParams();
  React.useEffect(() => {
    let routeParts = window.location.pathname.split("/");
    let varea = routeParts[4]; //searchParams.get('type');
    let area = routeParts[3];
    setArea(area);
    if (varea) {
      setViewArea(varea);
    } else {
      if (window.location.pathname.includes("summary")) {
        setViewArea("summary");
      } else if (window.location.pathname.includes("detail")) {
        setViewArea("detail");
      } else {
        setViewArea("overview");
      }
    }

    let _alarmType = searchParams.get("type");
    if (_alarmType) {
      setViewType(_alarmType);
    }
  }, [location]);

  React.useEffect(() => {
    // updateIncidentsCount();
    props.acquireToken(authSuccessCallback);
  }, []);

  // const updateIncidentsCount = () => {
  //    props.acquireToken(authSuccessCallback);
  // }

  const authSuccessCallback = (token) => {
    // console.log('test44343');
    if (token) {
      MonitoringService.GetMonitoringHome(token).then((response) => {
        if (response && response.status == 200) {
          response = response.data;
          let _configRules = {};
          Object.keys(response.ConfigRules).map((v) => {
            _configRules[v] = JSON.parse(response.ConfigRules[v]);
          });
          setRouteInLocalStorage("configRules", JSON.stringify(_configRules));
          // setMonitoringHome(response);
        } else if (response && response.status == 401) {
          props.viewStatus.InformChildPageStatus(response.status);
        } else {
          props.viewStatus.InformChildPageStatus(500);
        }

        setLoading(false);
      });
      let _params = {
        instanceId: 0,
        incidentLevelId: -1,
        appliedFilters: 0 ? [`InstanceId IN (0)`] : [],
      };
      //   MonitoringService.GetDbMonAndProvIncCount(token,_params).then((response) => {
      //     if(response && response.status==200){
      //       response=response.data;
      //       //alert(response.DbMonCritical);
      //       //setIncidents(response);
      //       setdbInsCriCount(response.DbMonCritical);
      //       setdbInsWarCount(response.DbMonWarning);
      //       setprovInsCriCount(response.ProvCritical);
      //       setprovInsWarCount(response.ProvWarning);

      //     }
      //     else if(response && response.status==401){
      //         props.viewStatus.InformChildPageStatus(response.status);
      //       }
      //       else {
      //         props.viewStatus.InformChildPageStatus(500);
      //       }

      //     //setLoaded(true);
      // });
    }
  };

  return (
    <>
      <div className="dashboard-top">
        <div className="row">
          <div className="col-sm-12 col-xs-12 mb-2">
            <Grid columns={8} style={{ gridGap: "10px" }}>
              <Card
                className={`card card-infra ${
                  area == "infra" ? "selected" : ""
                }`}
                elevated
              >
                <Card.Body>
                  <Toolbar
                    items={[
                      {
                        key: "custom-text",
                        content: <Text content="Infrastructure" />,
                        kind: "custom",
                        className: "heading subhead",
                        fitted: "horizontally",
                      },
                    ]}
                  ></Toolbar>
                  <Toolbar
                    items={[
                      {
                        key: "custom-infra-incident",
                        content: (
                          <Button
                            className={`${
                              area == "infra" && viewArea == "alarms"
                                ? "selected"
                                : ""
                            }`}
                            icon={
                              <div className="incident-counts flex1">
                                <span className="critical">
                                  {!loading && props.monitoringHome
                                    ? props.monitoringHome.InfraIncidentCounter
                                        ?.Critical
                                    : "-"}
                                </span>
                                <span className="warning">
                                  {!loading && props.monitoringHome
                                    ? props.monitoringHome.InfraIncidentCounter
                                        ?.Warning
                                    : "-"}
                                </span>
                              </div>
                            }
                            content="Incidents"
                            iconPosition="after"
                            onClick={() =>
                              routeChange(
                                "/dashboards/monitoring/infra/alarms?type=critical",
                                "alarms",
                                "infra"
                              )
                            }
                          />
                        ),
                        focusable: true,
                        kind: "custom",
                        className: `btn multi btnincdent ${
                          area == "infra" && viewArea == "alarms"
                            ? "selected"
                            : ""
                        }`,
                        fitted: "horizontally",
                      },
                      {
                        key: "custom-infra-detail",
                        kind: "custom",
                        content: (
                          <Tooltip
                            pointing
                            iconOnly
                            trigger={
                              <Button
                                className={`${
                                  area == "infra" && viewArea == "detail"
                                    ? "selected"
                                    : ""
                                }`}
                                icon={<BroadcastIcon />}
                                text
                                onClick={() =>
                                  routeChange(
                                    "/dashboards/monitoring/infra/detail",
                                    "detail",
                                    "infra"
                                  )
                                }
                              />
                            }
                            content="Detail"
                          />
                        ),
                        fitted: "horizontally",
                        className: `card-actions ${
                          area == "infra" && viewArea == "detail"
                            ? "selected"
                            : ""
                        }`,
                      },
                      {
                        key: "custom-infra-summary",
                        kind: "custom",
                        content: (
                          <Tooltip
                            pointing
                            iconOnly
                            trigger={
                              <Button
                                className={`${
                                  area == "infra" && viewArea == "summary"
                                    ? "selected"
                                    : ""
                                }`}
                                icon={<TranscriptIcon />}
                                text
                                onClick={() =>
                                  routeChange(
                                    "/dashboards/monitoring/infra/summary",
                                    "summary",
                                    "infra"
                                  )
                                }
                              />
                            }
                            content="Summary"
                          />
                        ),
                        fitted: "horizontally",
                        className: `card-actions ${
                          area == "infra" && viewArea == "summary"
                            ? "selected"
                            : ""
                        }`,
                      },
                    ]}
                  ></Toolbar>
                  <BroadcastIcon outline rotate={0} size="largest" />
                </Card.Body>
              </Card>
              <Card
                className={`card card-portal ${
                  area == "portal" ? "selected" : ""
                }`}
                elevated
              >
                <Card.Body>
                  <Toolbar
                    items={[
                      {
                        key: "custom-text",
                        content: <Text content="Data" />,
                        kind: "custom",
                        className: "heading subhead",
                        fitted: "horizontally",
                      },
                      {
                        key: "custom-text",
                        content:   <img src={StarCustomer} title="Priority Customers" className="StarCustomer" onClick={() => routeChange(
                                "/dashboards/monitoring/portal/prioritycustomer?type=critical",
                                "alarms",
                                "portal"
                              )} style={{ cursor: 'pointer' }} />,
                        kind: "custom",
                        className: "heading subhead",
                        fitted: "horizontally",
                      },
                    ]}
                  ></Toolbar>
                  <Toolbar
                    items={[
                      {
                        key: "custom-portal-incident",
                        content: (
                          <Button
                            className={`${
                              area == "portal" && viewArea == "alarms"
                                ? "selected"
                                : ""
                            }`}
                            icon={
                              <div className="incident-counts flex1">
                                <span className="critical">
                                  {!loading && props.monitoringHome
                                    ? props.monitoringHome.DataIncidentCounter
                                        ?.Critical
                                    : "-"}
                                </span>
                                <span className="warning">
                                  {!loading && props.monitoringHome
                                    ? props.monitoringHome.DataIncidentCounter
                                        ?.Warning
                                    : "-"}
                                </span>
                              </div>
                            }
                            content="Incidents"
                            onClick={() =>
                              routeChange(
                                "/dashboards/monitoring/portal/alarms?type=critical",
                                "alarms",
                                "portal"
                              )
                            }
                            iconPosition="after"
                          />
                        ),
                        focusable: true,
                        kind: "custom",
                        className: `btn multi ${
                          area == "portal" && viewArea == "alarms"
                            ? "selected"
                            : ""
                        }`,
                        fitted: "horizontally",
                      },
                      {
                        key: "custom-portal-detail",
                        kind: "custom",
                        content: (
                          <Tooltip
                            pointing
                            trigger={
                              <Button
                                className={`${
                                  area == "portal" && viewArea == "detail"
                                    ? "selected"
                                    : ""
                                }`}
                                icon={<AppsIcon />}
                                text
                                iconOnly
                                onClick={() =>
                                  routeChange(
                                    "/dashboards/monitoring/portal/detail?state=critical",
                                    "detail",
                                    "portal"
                                  )
                                }
                              />
                            }
                            content="Detail"
                          />
                        ),
                        fitted: "horizontally",
                        className: `card-actions ${
                          area == "portal" && viewArea == "detail"
                            ? "selected"
                            : ""
                        }`,
                      },
                      {
                        key: "custom-portal-summary",
                        kind: "custom",
                        content: (
                          <Tooltip
                            pointing
                            trigger={
                              <Button
                                className={`${
                                  area == "portal" && viewArea == "summary"
                                    ? "selected"
                                    : ""
                                }`}
                                icon={<TranscriptIcon />}
                                text
                                iconOnly
                                onClick={() =>
                                  routeChange(
                                    "/dashboards/monitoring/portal/summary",
                                    "summary",
                                    "portal"
                                  )
                                }
                              />
                            }
                            content="Summary"
                          />
                        ),
                        fitted: "horizontally",
                        className: `card-actions ${
                          area == "portal" && viewArea == "summary"
                            ? "selected"
                            : ""
                        }`,
                      },
                    ]}
                  ></Toolbar>
                  <AppsIcon outline rotate={0} size="largest" />
                </Card.Body>
              </Card>
              <Card
                className={`card card-service ${
                  area == "service" ? "selected" : ""
                }`}
                elevated
              >
                <Card.Body>
                  <Toolbar
                    items={[
                      {
                        key: "custom-text",
                        content: <Text content="Service" />,
                        kind: "custom",
                        className: "heading subhead",
                        fitted: "horizontally",
                      },
                      {
                        key: "custom-service-Hb",
                        content: (
                          <Button
                            className={`${
                              area == "service" &&
                              viewArea == "alarms" &&
                              viewType == "heartbeat"
                                ? "selected sniphb"
                                : "sniphb"
                            }`}
                            icon={
                              <div className="incident-counts flex1 hbstats">
                                <span className="critical">
                                  {!loading && props.monitoringHome
                                    ? props.monitoringHome.ServiceHeartbeat
                                    : "-"}
                                </span>
                              </div>
                            }
                            content="Heartbeat"
                            iconPosition="after"
                            onClick={() =>
                              routeChange(
                                "/dashboards/monitoring/service/alarms?type=heartbeat",
                                "alarms",
                                "service"
                              )
                            }
                          />
                        ),
                        focusable: true,
                        kind: "custom",
                        className: `btn multi ${
                          area == "service" && viewArea == "alarms"
                            ? "selected"
                            : ""
                        }`,
                        fitted: "horizontally",
                      },
                    ]}
                  ></Toolbar>
                  <Toolbar
                    items={[
                      {
                        key: "custom-service-incident",
                        content: (
                          <Button
                            className={`${
                              area == "service" &&
                              viewArea == "alarms" &&
                              viewType != "heartbeat"
                                ? "selected"
                                : ""
                            }`}
                            icon={
                              <div className="incident-counts flex1">
                                <span className="critical">
                                  {!loading && props.monitoringHome
                                    ? props.monitoringHome
                                        .ServiceIncidentCounter?.Critical
                                    : "-"}
                                </span>
                                <span className="warning">
                                  {!loading && props.monitoringHome
                                    ? props.monitoringHome
                                        .ServiceIncidentCounter?.Warning
                                    : "-"}
                                </span>
                              </div>
                            }
                            content="Incidents"
                            iconPosition="after"
                            onClick={() =>
                              routeChange(
                                "/dashboards/monitoring/service/alarms?type=critical",
                                "alarms",
                                "service"
                              )
                            }
                          />
                        ),
                        focusable: true,
                        kind: "custom",
                        className: `btn multi ${
                          area == "service" && viewArea == "alarms"
                            ? "selected"
                            : ""
                        }`,
                        fitted: "horizontally",
                      },
                      {
                        key: "custom-service-detail",
                        kind: "custom",
                        content: (
                          <Tooltip
                            pointing
                            trigger={
                              <Button
                                className={`${
                                  area == "service" && viewArea == "detail"
                                    ? "selected"
                                    : ""
                                }`}
                                icon={<PlugsIcon />}
                                text
                                iconOnly
                                onClick={() =>
                                  routeChange(
                                    "/dashboards/monitoring/service/detail",
                                    "detail",
                                    "service"
                                  )
                                }
                              />
                            }
                            content="Detail"
                          />
                        ),
                        fitted: "horizontally",
                        className: `card-actions ${
                          area == "service" && viewArea == "detail"
                            ? "selected"
                            : ""
                        }`,
                      },
                      {
                        key: "custom-service-summary",
                        kind: "custom",
                        content: (
                          <Tooltip
                            pointing
                            trigger={
                              <Button
                                className={`${
                                  area == "service" && viewArea == "summary"
                                    ? "selected"
                                    : ""
                                }`}
                                icon={<TranscriptIcon />}
                                text
                                iconOnly
                                onClick={() =>
                                  routeChange(
                                    "/dashboards/monitoring/service/summary",
                                    "summary",
                                    "service"
                                  )
                                }
                              />
                            }
                            content="Summary"
                          />
                        ),
                        fitted: "horizontally",
                        className: `card-actions ${
                          area == "service" && viewArea == "summary"
                            ? "selected"
                            : ""
                        }`,
                      },
                    ]}
                  ></Toolbar>
                  <PlugsIcon outline rotate={0} size="largest" />
                </Card.Body>
              </Card>
              <Card
                className={`card card-dbm ${
                  area == "dbmonitoring" ? "selected" : ""
                }`}
                elevated
              >
                <Card.Body>
                  <Toolbar
                    items={[
                      {
                        key: "custom-text",
                        content: <Text content="Db Monitoring" />,
                        kind: "custom",
                        className: "heading subhead",
                        fitted: "horizontally",
                      },
                    ]}
                  ></Toolbar>
                  <Toolbar
                    items={[
                      {
                        key: "custom-infra-incident",
                        content: (
                          <Button
                            className={`${
                              area == "dbmonitoring" && viewArea == "alarms"
                                ? "selected"
                                : ""
                            }`}
                            icon={
                              <div className="incident-counts flex1">
                                <span className="critical">
                                  {!loading && props.monitoringHome
                                    ? props.monitoringHome.DbMonitoring
                                        ?.Critical
                                    : "-"}
                                </span>
                                <span className="warning">
                                  {!loading && props.monitoringHome
                                    ? props.monitoringHome.DbMonitoring?.Warning
                                    : "-"}
                                </span>
                              </div>
                            }
                            content="Incidents"
                            iconPosition="after"
                            onClick={() =>
                              routeChange(
                                "/dashboards/monitoring/dbmonitoring/alarms?type=critical",
                                "alarms",
                                "dbmonitoring"
                              )
                            }
                          />
                        ),
                        focusable: true,
                        kind: "custom",
                        className: `btn multi ${
                          area == "dbmonitoring" && viewArea == "alarms"
                            ? "selected"
                            : ""
                        }`,
                        fitted: "horizontally",
                      },
                      {
                        key: "custom-service-detail",
                        kind: "custom",
                        content: (
                          <Tooltip
                            pointing
                            trigger={
                              <Button
                                className={`${
                                  area == "dbmonitoring" && viewArea == "token"
                                    ? "selected"
                                    : ""
                                }`}
                                icon={<SyncIcon />}
                                text
                                iconOnly
                                onClick={() =>
                                  routeChange(
                                    "/dashboards/monitoring/dbmonitoring/token",
                                    "token",
                                    "dbmonitoring"
                                  )
                                }
                              />
                            }
                            content="Refresh Token"
                          />
                        ),
                        fitted: "horizontally",
                        className: `card-actions ${
                          area == "service" && viewArea == "detail"
                            ? "selected"
                            : ""
                        }`,
                      }
                      // {
                      //   key: 'custom-infra-summary',
                      //   kind: 'custom',
                      //   content: <Tooltip pointing iconOnly trigger={<Button className={`${area == 'dbmonitoring' && viewArea == 'summary' ? 'selected' : ''}`} icon={<TranscriptIcon />} text onClick={() => routeChange('/dashboards/monitoring/dbmonitoring/summary', 'summary', 'dbmonitoring')} />} content="Summary" />,
                      //   fitted: 'horizontally',
                      //   className: `card-actions ${area == 'dbmonitoring' && viewArea == 'summary' ? 'selected' : ''}`,
                      // },
                    ]}
                  ></Toolbar>
                  <BroadcastIcon outline rotate={0} size="largest" />
                </Card.Body>
              </Card>
              <Card
                className={`card card-provi ${
                  area == "provisioning" ? "selected" : ""
                }`}
                elevated
              >
                <Card.Body>
                  <Toolbar
                    items={[
                      {
                        key: "custom-text",
                        content: <Text content="Provisioning" />,
                        kind: "custom",
                        className: "heading subhead",
                        fitted: "horizontally",
                      },
                    ]}
                  ></Toolbar>
                  <Toolbar
                    items={[
                      {
                        key: "custom-infra-incident",
                        content: (
                          <Button
                            className={`${
                              area == "provisioning" && viewArea == "alarms"
                                ? "selected"
                                : ""
                            }`}
                            icon={
                              <div className="incident-counts flex1">
                                <span className="critical">
                                  {!loading && props.monitoringHome
                                    ? props.monitoringHome.Provisioning
                                        ?.Critical
                                    : "-"}
                                </span>
                                <span className="warning">
                                  {!loading && props.monitoringHome
                                    ? props.monitoringHome.Provisioning?.Warning
                                    : "-"}
                                </span>
                              </div>
                            }
                            content="Incidents"
                            iconPosition="after"
                            onClick={() =>
                              routeChange(
                                "/dashboards/monitoring/provisioning/alarms?type=critical",
                                "alarms",
                                "provisioning"
                              )
                            }
                          />
                        ),
                        focusable: true,
                        kind: "custom",
                        className: `btn multi ${
                          area == "provisioning" && viewArea == "alarms"
                            ? "selected"
                            : ""
                        }`,
                        fitted: "horizontally",
                      },
                      // {
                      //   key: 'custom-infra-summary',
                      //   kind: 'custom',
                      //   content: <Tooltip pointing iconOnly trigger={<Button className={`${area == 'provisioning' && viewArea == 'summary' ? 'selected' : ''}`} icon={<TranscriptIcon />} text onClick={() => routeChange('/dashboards/monitoring/provisioning/summary', 'summary', 'provisioning')} />} content="Summary" />,
                      //   fitted: 'horizontally',
                      //   className: `card-actions ${area == 'provisioning' && viewArea == 'summary' ? 'selected' : ''}`,
                      // },
                    ]}
                  ></Toolbar>
                  <BroadcastIcon outline rotate={0} size="largest" />
                </Card.Body>
              </Card>
              <Card
                className={`card card-ssl ${
                  area == "sslcertificate" ? "selected" : ""
                }`}
                elevated
              >
                <Card.Body>
                  <Toolbar
                    items={[
                      {
                        key: "custom-text",
                        content: <Text content="SSL Certificates" />,
                        kind: "custom",
                        className: "heading subhead",
                        fitted: "horizontally",
                      },
                    ]}
                  ></Toolbar>
                  <Toolbar
                    items={[
                      {
                        key: "custom-infra-incident",
                        content: (
                          <Button
                            className={`${
                              area == "sslcertificates" && viewArea == "alarms"
                                ? "selected"
                                : ""
                            }`}
                            icon={
                              <div className="incident-counts flex1">
                                <span className="critical">
                                  {!loading && props.monitoringHome
                                    ? props.monitoringHome.SslCertificates
                                        ?.Critical
                                    : "-"}
                                </span>
                                <span className="warning">
                                  {!loading && props.monitoringHome
                                    ? props.monitoringHome.SslCertificates?.Warning
                                    : "-"}
                                </span>
                              </div>
                            }
                            content="Incidents"
                            iconPosition="after"
                            onClick={() =>
                              routeChange(
                                "/dashboards/monitoring/sslcertificates/alarms?type=critical",
                                "alarms",
                                "sslcertificates"
                              )
                            }
                          />
                        ),
                        focusable: true,
                        kind: "custom",
                        className: `btn multi ${
                          area == "sslcertificates" && viewArea == "alarms"
                            ? "selected"
                            : ""
                        }`,
                        fitted: "horizontally",
                      },
                    ]}
                  ></Toolbar>
                  <BroadcastIcon outline rotate={0} size="largest" />
                </Card.Body>
              </Card>

              <Card
                className={`card card-app ${
                  area == "appregistrations" ? "selected" : ""
                }`}
                elevated
              >
                <Card.Body>
                  <Toolbar
                    items={[
                      {
                        key: "custom-text",
                        content: <Text content="App Registrations" />,
                        kind: "custom",
                        className: "heading subhead",
                        fitted: "horizontally",
                      },
                    ]}
                  ></Toolbar>
                  <Toolbar
                    items={[
                      {
                        key: "custom-infra-incident",
                        content: (
                          <Button
                            className={`${
                              area == "appregistrations" && viewArea == "alarms"
                                ? "selected"
                                : ""
                            }`}
                            icon={
                              <div className="incident-counts flex1">
                                <span className="critical">
                                  {!loading && props.monitoringHome
                                    ? props.monitoringHome.AppRegistrations
                                        ?.Critical
                                    : "-"}
                                </span>
                                <span className="warning">
                                  {!loading && props.monitoringHome
                                    ? props.monitoringHome.AppRegistrations?.Warning
                                    : "-"}
                                </span>
                              </div>
                            }
                            content="Incidents"
                            iconPosition="after"
                            onClick={() =>
                              routeChange(
                                "/dashboards/monitoring/appregistrations/alarms?type=critical",
                                "alarms",
                                "provisioning"
                              )
                            }
                          />
                        ),
                        focusable: true,
                        kind: "custom",
                        className: `btn multi ${
                          area == "appregistrations" && viewArea == "alarms"
                            ? "selected"
                            : ""
                        }`,
                        fitted: "horizontally",
                      },
                    ]}
                  ></Toolbar>
                  <BroadcastIcon outline rotate={0} size="largest" />
                </Card.Body>
              </Card>
              <Card
                className={`card card-ai ${
                  area == "aiservices" ? "selected" : ""
                }`}
                elevated
              >
                <Card.Body>
                  <Toolbar
                    items={[
                      {
                        key: "custom-text",
                        content: <Text content="Ai Services" />,
                        kind: "custom",
                        className: "heading subhead",
                        fitted: "horizontally",
                      },
                    ]}
                  ></Toolbar>
                  <Toolbar
                    items={[
                      {
                        key: "custom-infra-incident",
                        content: (
                          <Button
                            className={`${
                              area == "aiservices" && viewArea == "alarms"
                                ? "selected"
                                : ""
                            }`}
                            icon={
                              <div className="incident-counts flex1">
                                <span className="critical">
                                  {!loading && props.monitoringHome
                                    ? props.monitoringHome.AiServices
                                        ?.Critical
                                    : "-"}
                                </span>
                                <span className="warning">
                                  {!loading && props.monitoringHome
                                    ? props.monitoringHome.AiServices?.Warning
                                    : "-"}
                                </span>
                              </div>
                            }
                            content="Incidents"
                            iconPosition="after"
                            onClick={() =>
                              routeChange(
                                "/dashboards/monitoring/aiservices/alarms?type=critical",
                                "alarms",
                                "provisioning"
                              )
                            }
                           /*onClick={() => alert("Coming Soon")}*/
                          />
                        ),
                        focusable: true,
                        kind: "custom",
                        className: `btn multi ${
                          area == "appregistrations" && viewArea == "alarms"
                            ? "selected"
                            : ""
                        }`,
                        fitted: "horizontally",
                      },
                    ]}
                  ></Toolbar>
                  <BroadcastIcon outline rotate={0} size="largest" />
                </Card.Body>
              </Card>
            </Grid>
          </div>
        </div>
      </div>
      <div className="dashboard-details mb-3">
        <div className="row">
          <div className="col-sm-12">
            <Outlet />
          </div>
        </div>
      </div>
    </>
  );
};

export default ProvisioningDashboard;
